(ns frontend.ui.component.lp-portal.report.body.voima.fund.controller
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.report.component.overview-figures.controller :as ov-ctl]
   [frontend.ui.component.lp-portal.report.component.waterfall-chart.controller :as
    waterfall-chart-ctl]
   [frontend.ui.component.lp-portal.report.component.multi-chart.controller :as multi-controller]
   [frontend.ui.component.lp-portal.report.component.map.controller :as map]))


(defn ->ui-data
  [{:keys [dynamic-data report-data] :as props}]
  {:fund-name             (:fund-name report-data)
   :reference-date        (get-in report-data [:reference-date])
   :reporting-period      (:reporting-period report-data)
   :overview-figures      (report-ctl/with-footnote
                           (update props :dynamic-path concat [:overview])
                           :overview-figures-footnotes
                           (ov-ctl/figures (get-in report-data [:overview-figures])))
   :executive-summary     {:case-overview (report-ctl/rich-content
                                           props
                                           :case-overview-text)
                           :executive-summary-figures (report-ctl/with-footnote
                                                       props
                                                       :executive-summary-figures-footnotes
                                                       (:executive-summary report-data))}
   :fund-overview         {:total-investment (report-ctl/with-footnote
                                              props
                                              :total-investment-footnotes
                                              (multi-controller/multi-chart-ctl
                                               (:total-investment report-data)
                                               report-data))
                           :number-of-employees (report-ctl/with-footnote
                                                 props
                                                 :number-of-employees-footnotes
                                                 (multi-controller/multi-chart-ctl
                                                  (:number-of-employees-active-portfolio report-data)
                                                  report-data))
                           :initial-and-follow-on-investments (report-ctl/with-footnote
                                                               props
                                                               :initial-and-follow-on-investments-footnotes
                                                               (multi-controller/multi-chart-ctl
                                                                (:initial-and-follow-on-investments report-data)
                                                                report-data))
                           :fund-value-bridge (report-ctl/with-footnote
                                               props
                                               :fund-value-bridge-footnotes
                                               (waterfall-chart-ctl/chart-config
                                                (:fund-value-bridge report-data)
                                                report-data))
                           :total-investment-by-geography (report-ctl/with-footnote
                                                           props
                                                           :total-investment-by-geography-footnotes
                                                           (multi-controller/multi-chart-ctl
                                                            (:total-investment-by-geography report-data)
                                                            report-data))
                           :combined-revenue-active-portfolio (report-ctl/with-footnote
                                                               props
                                                               :combined-revenue-active-portfolio-footnotes
                                                               (multi-controller/multi-chart-ctl
                                                                (:combined-revenue-active-portfolio report-data)
                                                                report-data))
                           :value-progression (report-ctl/with-footnote
                                               props
                                               :value-progression-footnotes
                                               (multi-controller/multi-chart-ctl
                                                (:value-progression report-data)
                                                report-data))
                           :historical-fund-performance (report-ctl/with-footnote
                                                         props
                                                         :historical-fund-performance-footnotes
                                                         (multi-controller/multi-chart-ctl
                                                          (:historical-fund-performance report-data)
                                                          report-data))
                           :dealflow-map (report-ctl/with-footnote
                                          props
                                          :dealflow-map-footnotes
                                          (map/map-controller (:dealflow-map report-data) map/highcharts-europe-topo))
                           :investments-map (report-ctl/with-footnote
                                             props
                                             :investments-map-footnotes
                                             (map/map-controller (:investments-map report-data) map/highcharts-europe-topo))
                           :net-asset-value (report-ctl/with-footnote
                                             props
                                             :net-asset-value-footnotes
                                             (:net-asset-value report-data))
                           :key-metrics (report-ctl/with-footnote
                                         props
                                         :key-metrics-footnotes
                                         (:key-metrics report-data))
                           :management-fees (report-ctl/with-footnote
                                             props
                                             :management-fees-footnotes
                                             (:management-fees report-data))
                           :transaction-and-other-fees (report-ctl/with-footnote
                                                        props
                                                        :transaction-and-other-fees-footnotes
                                                        (:transaction-and-other-fees report-data))
                           :carried-interest (report-ctl/with-footnote
                                              props
                                              :carried-interest-footnotes
                                              (:carried-interest report-data))
                           :fund-operating-expenses (report-ctl/with-footnote
                                                     props
                                                     :fund-operating-expenses-footnotes
                                                     (:fund-operating-expenses report-data))
                           :bridge-finance-and-fund-leverage (report-ctl/with-footnote
                                                              props
                                                              :bridge-finance-and-fund-leverage-footnotes
                                                              (:bridge-finance-and-fund-leverage report-data))
                           :bridging-facility (report-ctl/with-footnote
                                               props
                                               :bridging-facility-footnotes
                                               (:bridging-facility report-data))}
   :portfolio-information {:portfolio-summary (report-ctl/with-footnote
                                               props
                                               :portfolio-summary-footnotes
                                               (:portfolio-summary report-data))}
   :investor-information  {:capital-account-year-to-date    (report-ctl/with-footnote
                                                             props
                                                             :capital-account-year-to-date-footnotes
                                                             (:capital-account-year-to-date report-data))
                           :capital-account-since-inception (report-ctl/with-footnote
                                                             props
                                                             :capital-account-since-inception-footnotes
                                                             (:capital-account-since-inception report-data))}
   :data-dump             (report-ctl/with-footnote
                           props
                           :data-dump-footnotes
                           (:data-dump report-data))})


